(ns hypnos.sleeplab.tile.table.consults
  "The consults table."
  (:require [hypnos.i18n :refer [tr]]
            [hypnos.sleeplab.subs]
            [hypnos.time :as t]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

#_(defn- therapist
  "Therapist working on the patient consult."
  [consult]
  (str (get-in consult [:consult/user :user/first-name])
       " "
       (get-in consult [:consult/user :user/last-name])))

(defn- header
  "Patients table header (row)."
  []
  [:tr
   [:th]
   [:th (tr :ui.label/org)]
   ;; [:th (tr :ui.label/therapist)]
   [:th (tr :ui.label/patient-key)]
   [:th (tr :ui.label/last-name)]
   [:th (tr :ui.label/first-name)]
   [:th (tr :ui.label/dob)]
   [:th (tr :ui.label/consult) " " (tr :ui.label/status)]
   [:th (tr :ui.label/modified-on)]
   [:th]
   [:th]])

(defn- row
  "Table row containing the consult/patient details."
  [consult]
  [:tr
   [:td]
   [:td (get-in consult [:consult/patient :patient/organization :organization/key])]
   ;; [:td (therapist consult)]
   [:td (get-in consult [:consult/patient :patient/key])]
   [:td (get-in consult [:consult/patient :patient/last-name])]
   [:td (get-in consult [:consult/patient :patient/first-name])]
   [:td (t/format-date t/MMM-d-YYYY (get-in consult [:consult/patient :patient/dob]))]
   [:td (tr :ui/consult-status (:consult/status consult))]
   [:td (t/format-date t/MM-dd-YYYY-HH-MM-SS (t/to-default-time-zone (:consult/recorded-at consult)))]
   [:td [:div.buttons.is-right.has-addons
         [:a.button.is-small.is-link
          {:href (str "/patient/" (get-in consult [:consult/patient :patient/id]))}
          [:span.icon [:i.mdi.mdi-eye]]]]]
   [:td]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Table

(defn table
  "The consults table for the passed in states."
  [consult-states]
  (let [consults          (rf/subscribe [:sleeplab/consults])
        loading?          (rf/subscribe [:sleeplab/gql-request-in-progress?])
        filtered-consults (filter #(contains? consult-states (:consult/status %)) (:consults @consults))]
    (cond
      @loading?
      [:div.card-content
       [:section.section
        [:div.content.has-text-grey.has-text-centered
         [:p
          [:span.icon.is-large
           [:i.mdi.mdi-loading.mdi-48px.mdi-spin]]]
         [:p (tr :ui.label/loading)]]]]
      (empty? filtered-consults)
      [:div.card-content
       [:section.section
        [:div.content.has-text-grey.has-text-centered
         [:p
          [:span.icon.is-large
           [:i.mdi.mdi-account-outline.mdi-48px]]]
         [:p (tr :ui.label/no-consults)]]]]
      :else
      [:div.table-container
       [:table.table.is-fullwidth.is-striped.is-hoverable.is-sortable.is-fullwidth
        [:thead
         [header]]
        [:tbody
         (for [consult filtered-consults]
           ^{:key (:consult/id consult)} [row consult])]]])))
